module.exports = __webpack_public_path__ + "assets/563b322fd44139f009680410be9e7f68.svg";